<template>
    <div class="container">
        <h1 class="page-title h1 mt-4">Tworzenie użytkownika sklepowego</h1>
        <div class="row pt-4">
            <div class="col-lg-6 col-12 mb-4">
                <div class="card p-4">
                    <form>
                        <h2 class="h6 mb-3">Nazwa</h2>
                        <the-input
                            id="mp-userAlias"
                            style="max-width: 400px"
                            class="mb-4"
                            :type="'text'"
                            :label="'Nazwa'"
                            :name="'mp-userAlias'"
                            @input="userAlias = $event"
                            :text="userAlias"
                        />
                    </form>
                    <form>
                        <h2 class="h6 mb-3">Ustaw hasło</h2>
                        <div>
                            Hasło powinno zawierać:
                            <ul>
                                <li>przynajmniej 6 znaków</li>
                                <li>co najmniej 1 małą literę</li>
                                <li>co najmniej 1 wielką literę</li>
                                <li>co najmniej 1 cyfrę</li>
                                <li>co najmniej 1 znak specjalny (@$!%*?&)</li>
                            </ul>
                        </div>
                        <div style="max-width: 400px">
                            <the-input
                                class="mb-4"
                                id="mp-newPassword"
                                :type="'password'"
                                :invalid="invalidNew"
                                :invalidFeedback="'Hasło nie spełnia wymagań.'"
                                label="Hasło"
                                name="'mp-newPassword'"
                                @input="passwords.newPassword = $event"
                                :text="passwords.newPassword"
                            />
                            <the-input
                                class="mb-0"
                                id="mp-repeatNewPassword"
                                :type="'password'"
                                :invalid="invalidRepeat"
                                :invalidFeedback="
                                    'Podane hasła nie są identyczne.'
                                "
                                label="Powtórz hasło"
                                name="'mp-repeatNewPassword'"
                                @input="passwords.repeatNewPassword = $event"
                                :text="passwords.repeatNewPassword"
                            />
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-lg-6 col-12 mb-4">
                <div class="card p-4">
                    <div class="mb-4">
                        <store-user-permissions
                            :permissions="permissions"
                            title="Uprawnienia"
                            sub-title="Nadaj uprawnienie do zarządzania promocjami:ienia"
                            is-editable
                            @onChange="permissions = $event"
                        />
                    </div>
                    <div>
                        <h2 class="h6 mb-3">Sklepy</h2>
                        <div
                            class="mb-3 d-flex align-items-center"
                            :class="{ 'text-danger': invalidShopSelection }"
                        >
                            <a-icon
                                icon="InvalidMark"
                                v-if="invalidShopSelection"
                                class="mr-2"
                                style="width: 18px; height: 18px"
                            />
                            Wybierz sklepy do których użytkownik będzie miał
                            dostęp:
                        </div>
                        <div style="overflow-y: scroll; height:250px;">
                            <ui-checkbox-input
                                class="text-sm"
                                v-for="(shop, id) in locationsData"
                                :key="id"
                                :name="'location-' + id"
                                @change="
                                    val => onSelectedLocationChange(shop, val)
                                "
                                :value="
                                    shopIds.some(r =>
                                        shopIds.includes(shop.value)
                                    )
                                "
                                :label="shop.label"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
                <router-link class="btn btn-outline" to="store-users">
                    Anuluj
                </router-link>
                <button
                    type="button"
                    class="btn btn-secondary ml-2"
                    data-dismiss="modal"
                    @click="createUser"
                >
                    Zapisz
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddStoreUser',
    data() {
        return {
            passwords: {
                newPassword: '',
                repeatNewPassword: ''
            },
            invalidRepeat: false,
            invalidNew: false,
            invalidShopSelection: false,
            shopIds: [],
            locationsData: [],
            userAlias: null,
            permissions: ['promotions.read', 'promotions.code.mapping']
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.$store
                .dispatch('extendedDataFetch', {
                    includes: 'locations'
                })
                .then(res => {
                    if (res) {
                        this.locationsData = res.data.data.locations
                            .filter(el => el.status === 'Y')
                            .map(el => {
                                return {
                                    value: el.id,
                                    label:
                                        el.full_name +
                                        ', ' +
                                        this.getShopAddress(el.address)
                                }
                            })
                    }
                })
        },
        validateNewPassword(value) {
            const validationResult = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@$%&?*]).{6,}$/.test(
                value
            )
            this.invalidNew = !validationResult
            return validationResult
        },
        validateRepeatPassword(value) {
            const validationResult = this.passwords.newPassword === value
            this.invalidRepeat = !validationResult
            return validationResult
        },
        validateShopSelection(shopIds) {
            const isShopSelected = shopIds.length
            this.invalidShopSelection = !isShopSelected
            return isShopSelected
        },
        createUser() {
            this.validateNewPassword(this.passwords.newPassword)
            this.validateRepeatPassword(this.passwords.repeatNewPassword)
            this.validateShopSelection(this.shopIds)
            if (
                !this.invalidNew &&
                !this.invalidRepeat &&
                !this.invalidShopSelection
            ) {
                this.$store.dispatch('addStoreUser', {
                    shop_id: this.shopIds,
                    password: this.passwords.newPassword,
                    user_alias: this.userAlias,
                    permissions: this.permissions
                })
            }
        },
        getShopAddress(address) {
            const {
                street,
                postal_code: postalCode,
                city,
                building,
                local
            } = address
            return `${street} ${building}${local ? '/' + local : ''}${
                postalCode ? ', ' + postalCode : ', '
            } ${city}`
        },
        onSelectedLocationChange(option, checked) {
            let tmp = this.shopIds
            if (checked) {
                tmp.push(option.value)
            } else {
                tmp = tmp.filter(e => e !== option.value)
            }
            this.shopIds = tmp
        }
    }
}
</script>
